



















































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import EmailTemplateDto from '@/models/EmailTemplates/EmailTemplateDto'
import EmailTemplateEdit from '@/components/EmailTemplates/EmailTemplateEdit.vue';
import EmailTemplateCreate from '@/components/EmailTemplates/EmailTemplateCreate.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'EmailTemplates',
  components: { EmailTemplateEdit, EmailTemplateCreate }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentEmailTemplate(null);
        AgencySettingsModule.getEmailIntegrationTemplates();
    }

    async updateCurrentEmailTemplate(emailTemplate: EmailTemplateDto) {
        AgencySettingsModule.updateCurrentEmailTemplate(emailTemplate);
    }

    get currentEmailTemplate() {
        return AgencySettingsModule.currentEmailTemplate;
    }

    get loading() {
        return AgencySettingsModule.loadingEmailTemplates;
    }

    get emailTemplates() {
        return AgencySettingsModule.emailTemplates;
    }

    async deleteEmailTemplate(emailTemplate: EmailTemplateDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the email template ' + emailTemplate.name + '?', options);
  }
}
